export const STARTER_ONE_SEAT_LIMIT_DATE = '2024-01-11';
